import React, { useState } from "react";
import { Icon, message, Upload } from "antd";
import {
    RcCustomRequestOptions,
    UploadChangeParam,
    UploadFile
} from "antd/lib/upload/interface";
import { uploadToQiNiu } from "../../../../API";
import { checkCourseWareStr } from "../../../../Utils/filter";
import { RcFile } from "antd/lib/upload";

interface FileUploaderProps {
    disabled: boolean;
    onChange?(value?: string[]): void;
}

export default function FileUploader({
    disabled,
    onChange
}: FileUploaderProps) {
    const [fileCount, setFileCount] = useState(0);

    function onFileChange(info: UploadChangeParam) {
        setFileCount(info.fileList.length);

        onChange?.(
            info.fileList
                .filter(item => item.response?.url)
                .map(item => item.response.url)
        );
    }

    function customRequest(options: RcCustomRequestOptions) {
        uploadToQiNiu(options.file, {
            keepAttName: false,
            onUploadProgress: (file, percent) =>
                options.onProgress({ percent }, file)
        })
            .then(res => {
                options.onSuccess(res, options.file);
            })
            .catch(error => {
                options.onError(error);
            });
    }

    const beforeUpload = (file: RcFile) => {
        if (checkCourseWareStr(file).next) {
            return true;
        } else {
            message.error(checkCourseWareStr(file).msg);
            return Promise.reject(file);
        }
    };

    function onDownload(file: UploadFile) {
        window.open(file.response?.url);
    }

    return (
        <Upload
            listType="picture-card"
            onChange={onFileChange}
            customRequest={customRequest}
            onPreview={onDownload}
            onDownload={onDownload}
            beforeUpload={beforeUpload}
            accept="image/*"
            multiple
            disabled={disabled}>
            {fileCount >= 9 ? null : (
                <div>
                    <Icon type="plus" />
                    <div className="ant-upload-text">上传图片</div>
                </div>
            )}
        </Upload>
    );
}
